import "core-js/modules/es.array.is-array";
export default function isConfigValid(configObject, device) {
  if (configObject) {
    if (device && device.isDesktop()) {
      var configKeys = ['navigationBarItems', 'profileBarItems', 'leftLinks', 'rightLinks'];

      for (var _i = 0, _configKeys = configKeys; _i < _configKeys.length; _i++) {
        var configKey = _configKeys[_i];
        var config = configObject[configKey];

        if (Array.isArray(config) && config.length) {
          return true;
        }
      }
    } else if (configObject.size) {
      return true;
    }
  }

  return false;
}